// extracted by mini-css-extract-plugin
export default {"blocks":"ChangeInfoForm_blocks__FBxwj","avatarBlock":"ChangeInfoForm_avatarBlock__HeVwv","inputsBlock":"ChangeInfoForm_inputsBlock__nn-d7"};